import './NewUserContent.css';
import SmallLogo from '../../assets/images/small-logo.svg';
import setting from '../../assets/images/setting.svg';
import logoutIcon from '../../assets/images/logout.svg';
import avatar from '../../assets/images/avatar.png';
import { logout } from '../../service/authService';
import AllConsents from '../../pages/AllConsents/AllConsents';

const NewUserContent = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  return (
    <div className='newUserContent'>
      <header>
        <img src={SmallLogo} alt="SmallLogo" />
        <div className='d-flex gap-24 align-items-center'>
          <img src={avatar} alt="avatar" className='logoimg' />
          <span className='userName'>{userInfo?.FirstName}</span>
          <img src={setting} alt="setting" />
          <img src={logoutIcon} alt="logout" className='cursor-pointer' onClick={logout} />
        </div>
      </header>

      <h4 className='font-36'>Welcome {userInfo?.FirstName}!</h4>
      <AllConsents />
    </div>
  );
};

export default NewUserContent;
